function getHotelContext() {
  if (typeof window === 'undefined') return {};
  const ctx = window.DJANGO_CONTEXT || window.djangoContext || {};
  return ctx.selectedHotel || ctx.hotel || {};
}

export function isAutoGstEnabled() {
  return Boolean(getHotelContext().auto_gst_enabled);
}

export function setAutoGstEnabledInContext(enabled) {
  if (typeof window === 'undefined') return;
  const ctx = window.DJANGO_CONTEXT || window.djangoContext;
  if (!ctx) return;
  const next = Boolean(enabled);
  if (ctx.selectedHotel) ctx.selectedHotel.auto_gst_enabled = next;
  if (ctx.hotel) ctx.hotel.auto_gst_enabled = next;
}
